import { jwtDecode } from "jwt-decode";
import { LoginResult, User } from "./models/AccountModels";

const getDecodedAccessToken = (token: string): any => {
  try {
    return jwtDecode(token);
  } catch (Error) {
    return null;
  }
}

const createAccount = (accessToken: string): User | undefined => {
  const jwt = getDecodedAccessToken(accessToken);
  if (!jwt) {
    return undefined;
  }

  return {
    id: jwt.sub,
    firstName: jwt.given_name,
    lastName: jwt.family_name,
    role: jwt.role,
    companyType: jwt.company_type ? parseInt(jwt.company_type, 10) : undefined,
    // phoneNumber is NOT in JWT - fetched from API when needed
  };
}

class AccountContext {
  get user(): User | undefined {
    return this.accessToken ? createAccount(this.accessToken) : undefined;
  }

  get accessToken(): string | undefined {
    const accessToken = localStorage.getItem('accessToken');
    return accessToken || undefined;
  }

  finishLogin(loginResult: LoginResult) {
    localStorage.setItem('accessToken', loginResult.accessToken);
  }

  logout() {
    localStorage.removeItem('accessToken');
  }
}

export default new AccountContext();